export default __webpack_public_path__ + "static/media/fastclix_lancets@3x.544e8dd0.webp";